// BSL-MUS §6 — Müşteri kaydı turları. Ekran başına en çok 3 balon, metin ≤ 140 karakter.
// Bir `data-tur` elemanı silinir/taşınırsa bu dosya aynı commit'te düzeltilir (çatı §12).
// pencere: true → sayfanın bir penceresinin turu; ? menüsü «Bu ekranı tanıt» bunu seçmez.
export default {
  musteriListesi: {
    yol: "/musteri/musterilistesi",
    adimlar: [
      { hedef: '[data-tur="musteri-yeni"]', metin: "Müşterilerinizi buradan ekleyin. Satış, randevu ve ders kaydı için müşteri gerekir." },
      { hedef: '[data-tur="musteri-toplu"]', metin: "Listeniz Excel'deyse şablonu indirip tek seferde yükleyin." },
      { hedef: '[data-tur="musteri-sube"]', metin: "Müşteri bir şubeye bağlıdır; liste seçili şubeyi gösterir." },
    ],
  },
  yeniMusteri: {
    yol: "/musteri/yenimusteri",
    adimlar: [
      { hedef: '[data-tur="musteri-isim"]', metin: "Ad soyad ya da firma adı. Aynı adla ikinci müşteri açılmaz." },
      { hedef: '[data-tur="musteri-telefon"]', metin: "Cep telefonu. Hatırlatma ve WhatsApp mesajları bu numaraya gider." },
      { hedef: '[data-tur="musteri-eposta"]', metin: "Satış fişi e-postayla gider; e-postasız müşteriye satış yapılamaz." },
    ],
  },
  musteriToplu: {
    yol: "/musteri/musterilistesi",
    pencere: true,
    adimlar: [
      { hedef: '[data-tur="toplu-sablon"]', metin: "Önce şablonu indirin. Başlık satırını silmeyin; Şube boş kalırsa seçili şubeye yüklenir." },
      { hedef: '[data-tur="toplu-dosya"]', metin: "Doldurduğunuz dosyayı seçin; ilk satırlar önizlenir." },
      { hedef: '[data-tur="toplu-yukle"]', metin: "Yükleyin. Eklenemeyen satırlar nedeniyle birlikte listede kalır." },
    ],
  },
};
